<script lang="ts" setup>
  import type { Song } from '../../../../shared/api/song.ts';
  import { Spinner } from '../../../../shared/ui/spinner';
  import SongSearchInput from './SongSearchInput.vue';
  import SuggestionList from './SuggestionList.vue';

  defineProps<{
    placeholder: string;
    songs: Song[];
    isLoading: boolean;
    loadingLabel: string;
    disabled?: boolean;
    searchError?: string;
  }>();
  defineEmits<{ songSelected: [song: Song] }>();
  const query = defineModel<string>();
</script>

<template>
  <div class="song-search">
    <slot />
    <SongSearchInput v-model="query" :disabled="disabled" :error="searchError" :placeholder="placeholder" />
    <div v-if="songs.length > 0" class="suggestions" :inert="disabled">
      <SuggestionList :songs="songs" @song-selected="$emit('songSelected', $event)" />
      <div v-if="isLoading" class="loading-overlay">
        <Spinner />
        <span class="loading-label">{{ loadingLabel }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .song-search {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
    max-width: var(--control-max-width);
    min-height: 0;
    width: 100%;
  }

  .suggestions {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    position: relative;
    width: 100%;
  }

  .loading-overlay {
    align-items: center;
    background: var(--color-overlay);
    border-radius: var(--radius-control);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    inset: 0;
    justify-content: center;
    position: absolute;
  }

  .loading-label {
    color: var(--color-primary);
    font-size: var(--font-size-sm);
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
</style>
